// A section-scoped custom element survives theme-editor and section-API reloads.
if (!customElements.get('fbt-bundle')) {
  customElements.define('fbt-bundle', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }

    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.checkboxes = [...this.querySelectorAll('.v2-fbt__checkbox')];
      this.button = this.querySelector('[data-add-selected]');
      if (!this.checkboxes.length || !this.button) return;
      this.totals = JSON.parse(this.querySelector('[data-bundle-totals]')?.textContent || '[]');
      this.initialized = true;
      this.originalContent = this.button.innerHTML;
      this.checkboxes.forEach(checkbox => checkbox.addEventListener('change', () => this.updateTotal()));
      this.button.addEventListener('click', () => this.addSelected());
      this.updateTotal();
    }

    updateTotal() {
      let selection = 0, count = 0;
      this.checkboxes.forEach((checkbox, index) => {
        if (checkbox.checked) { selection += 2 ** index; count++; }
        checkbox.closest('.v2-fbt-card')?.classList.toggle('is-selected', checkbox.checked);
      });
      const price = this.querySelector('[data-total-price]');
      // Trusted HTML generated by Shopify's money filter in this section.
      if (price && this.totals?.[selection] !== undefined) price.innerHTML = this.totals[selection];
      const itemCount = this.querySelector('[data-item-count]');
      if (itemCount) itemCount.textContent = count;
      this.button.disabled = Boolean(this.pending || !count);
    }

    async addSelected() {
      if (this.pending || this.button.disabled) return;
      const items = this.checkboxes.filter(checkbox => checkbox.checked).map(checkbox => ({
        id: Number(checkbox.dataset.variantId), quantity: 1
      }));
      if (!items.length) return;
      this.pending = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.innerHTML = '<span>Adding to Cart...</span>';
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const payload = { items };
      if (cart) {
        payload.sections = cart.getSectionsToRender().map(section => section.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }
      let added = false;
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Unable to add selected items.');
        added = true;
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'fbt-bundle', productVariantIds: items.map(item => item.id)
        });
        if (!cart) { window.location.assign(window.routes.cart_url); return; }
        // A successful add and failed section render are different operations.
        // Never encourage another add when the items are already in the cart.
        if (payload.sections.some(id => !result.sections?.[id])) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        cart.renderContents(result);
        this.status('Added to cart.');
      } catch (error) {
        console.error('Bundle cart error:', error);
        if (added) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        this.status(error.message || 'Unable to add selected items. Please try again.', true);
      } finally {
        this.pending = false;
        this.button.innerHTML = this.originalContent;
        this.button.removeAttribute('aria-busy');
        this.updateTotal();
      }
    }

    status(message, error = false) {
      let status = this.querySelector('[data-bundle-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.bundleStatus = '';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        this.button.insertAdjacentElement('afterend', status);
      }
      status.textContent = message;
      status.classList.toggle('product-form__error-message', error);
    }
  });
}
